










































import { Component, Vue } from "vue-property-decorator";
import Header from "@/components/Header.vue";
import Menu from "@/components/Menu.vue";
import { BIcon, BIconBoxArrowRight } from "bootstrap-vue";
import NextPrevBtn from "@/components/NextPrevBtn.vue";
import Footer from "@/components/Footer.vue";
@Component({
  components: {
    Header,
    Menu,
    BIconBoxArrowRight,
    BIcon,
    NextPrevBtn,
    Footer
  }
})
export default class OnlineCultureMedia extends Vue {
  protected nxtprevOnlineCultureMedia = {
    BoolPrev: true,
    BoolNext: false,
    PrevImage: "/thumbnail1.png",
    NextImage: " ",
    PrevLink: "/CultureenLigne/CultureGenerale",
    NextLink: ""
  };
}
